var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16.777 16",
    width: 16.777,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.776 6.2a.728.728 0 0 1 -.262.484l-3.66 3.569.867 5.041a1.5 1.5 0 0 1 .01.2.6.6 0 0 1 -.106.358.356.356 0 0 1 -.308.146.814.814 0 0 1 -.4-.121l-4.529-2.377-4.527 2.379a.856.856 0 0 1 -.4.121.366.366 0 0 1 -.317-.146.6.6 0 0 1 -.106-.358 1.648 1.648 0 0 1 .02-.2l.867-5.041-3.673-3.571a.768.768 0 0 1 -.252-.484q0-.373.565-.464l5.061-.736 2.268-4.587q.192-.413.494-.413t.494.413l2.269 4.587 5.061.736q.565.091.565.464z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.7fb04836f9de08b914cbfc648762d20b.svg";
export { ForwardRef as ReactComponent };